import { Injectable } from '@angular/core';
import { NetworkService } from '../../shared/network.service';

@Injectable()
export class RolesService {
  constructor(private networkService: NetworkService) { }

  getRolesList() {
    return this.networkService.get("api/role", null, null, "bearer");
  }

  createRole(request: any) {
    return this.networkService.post("api/role", request, null, "bearer");
  }
  getAuditLogsListApi(roleId:any) {
    return this.networkService.get("api/role/auditLog/"+roleId,null,null,'bearer')
  }
}
